




























import Vue from 'vue';
import firebase from 'firebase/app';

// Components
import Sidebar from '@/components/Sidebar.vue';
import WarningDialog from '@/components/WarningDialog.vue';
import LoadingScreen from '@/components/LoadingScreen.vue';
import BreadcrumbBar from '@/components/BreadcrumbBar/Index.vue';
import Login from '@/views/Login.vue';

// Vuex
import { mapGetters } from 'vuex';

import gql from 'graphql-tag';

export default Vue.extend({
	name: 'App',

	components: {
		Sidebar,
		BreadcrumbBar,
		Login,
		WarningDialog,
		LoadingScreen,
	},

	data: () => ({
		drawer: null,
		mobile: window.innerWidth <= 768,
	}),

	computed: {
		...mapGetters(['firebase', 'loading', 'warning']),
	},

	apollo: {
		countries: gql`
			query MyQuery {
				countries {
					id
					name
					cities {
						id
						name
						locations {
							id
							name
							pitches {
								id
								name
							}
						}
					}
				}
			}
		`,
	},

	methods: {
		// ...mapActions(['init']),
	},

	beforeCreate() {
		// Firebase user listener
		firebase.auth().onAuthStateChanged(async user => {
			if (user) {
				// console.debug(user);
				this.$store.commit('setFirebase', user);
				this.$store.dispatch('getFootyUserByUid', user.uid);

				// TODO: Start using JWT and not UID
				// (firebase as any)
				// 	.auth()
				// 	.currentUser.getIdToken(/* forceRefresh */ true)
				// 	.then((idToken: string) => {
				// 		// Send token to your backend via HTTPS
				// 		// ...
				// 		console.debug(idToken);
				// 	})
				// 	.catch((error: string) => {
				// 		console.debug(error);
				// 	});
			} else {
				this.$store.commit('setFirebase', null);
				this.$store.commit('setCurrentUser', null);
			}
		});
	},

	created() {
		this.$store.dispatch('storeInit');
		this.mobile = innerWidth <= 768 || /Mobi|Android/i.test(navigator.userAgent);
		this.$store.commit('setIsMobile', this.mobile);

		addEventListener('resize', () => {
			this.mobile = innerWidth <= 768;
			this.$store.commit('setIsMobile', this.mobile);
		});
	},
});
